import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { OctTypeService } from '../../../services/index';

@Component({
    selector: 'add-edit-oct-type',
    templateUrl: './addEditOctType.component.html'
})
export class AddEditOctTypeComponent implements OnInit {

    @Output() octTypeLoadEvent = new EventEmitter();

    public title: string;
    public octTypeData: any = {};
    public isLoading: boolean = false;

    statusOptions = ['Active', 'Inactive'];

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private octTypeService: OctTypeService
    ) { }

    ngOnInit(): void {
        if (this.octTypeData.mode === 'Add') {
            this.octTypeData.status = 'Active';
        }
    }

    onSave(): void {
        this.isLoading = true;

        let params = {
            mode: this.octTypeData.mode,
            name: this.octTypeData.name,
            status: this.octTypeData.status
        };

        if (this.octTypeData.mode === 'Edit') {
            params['id'] = this.octTypeData.id;
        }

        this.octTypeService
            .addUpdateOctType(params)
            .then((res: any) => {
                this.isLoading = false;
                if (res && res.success) {
                    this.toasterService.pop({
                        type: 'success',
                        title: 'Success',
                        body: res.message
                    });
                    this.octTypeLoadEvent.emit();
                    this.bsModalRef.hide();
                } else {
                    this.toasterService.pop({
                        type: 'error',
                        title: 'Error',
                        body: res.message || 'Something went wrong'
                    });
                }
            })
            .catch(() => {
                this.isLoading = false;
                this.toasterService.pop({
                    type: 'error',
                    title: 'Error',
                    body: 'Something went wrong'
                });
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/octType/addEditOctType.component.ts